import React from 'react';
import styled from 'styled-components';
import SkeletonLoader from './SkeletonLoader';

const ExampleContainer = styled.div`
  max-width: 600px;
  margin: 2rem auto;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

const ExampleSection = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h3`
  margin-bottom: 1rem;
`;

const Description = styled.p`
  margin-bottom: 1rem;
  font-size: 0.9rem;
  color: #666;
`;

/**
 * SkeletonLoaderExample Component
 * 
 * Demonstrates different configurations of the SkeletonLoader component
 */
const SkeletonLoaderExample = () => {
  return (
    <ExampleContainer>
      <Title>Skeleton Loader Examples</Title>
      
      <ExampleSection>
        <Description>Default configuration: ['L', 'F', 'L', 'F', 'F']</Description>
        <SkeletonLoader />
      </ExampleSection>
      
      <ExampleSection>
        <Description>Form-like configuration: ['L', 'F', 'L', 'F', 'L', 'F']</Description>
        <SkeletonLoader config={['L', 'F', 'L', 'F', 'L', 'F']} />
      </ExampleSection>
      
      <ExampleSection>
        <Description>Table-like configuration: ['F', 'F', 'F', 'F']</Description>
        <SkeletonLoader config={['F', 'F', 'F', 'F']} />
      </ExampleSection>
      
      <ExampleSection>
        <Description>Mixed configuration: ['L', 'L', 'F', 'L', 'F', 'F']</Description>
        <SkeletonLoader config={['L', 'L', 'F', 'L', 'F', 'F']} />
      </ExampleSection>
    </ExampleContainer>
  );
};

export default SkeletonLoaderExample;
